<template>
  <div class="container">
    <ModelConfig
      :secTitle="
        'Selecione a <b>Cor Exterior</b> do seu <b>' +
        this.resumeData.model +
        '</b>'
      "
      :showLeftCol="showCarLook"
      :showRigthCol="showCarOptions"
    >
      <template v-slot:carLook>
        <Model :isMobile="isMobile" :objImgs="imgsArr" />
      </template>
      <template v-slot:carOptions>
        <p class="sidebarTitle">
          <b>Selecionar o {{ staticText.dsgExtLabels[0] }}</b>
        </p>
        <DetailsViewNav
          :isMobile="isMobile"
          :showContent="showCarOptions"
          @change-view="displayCarOptions"
        >
          <span
            ><b>Selecionar {{ staticText.dsgExtLabels[0] }}</b> (
            {{ getAllColorsLenght }} {{ staticText.dsgExtLabels[1] }})</span
          >
        </DetailsViewNav>
        <div v-if="getAllColorsLenght == 0">
          <p>
            Lamentamos, no momento não há cores disponíveis para a respetiva
            versão
          </p>
          <p>Por favor, tente mais tarde.</p>
        </div>
        <div v-else class="container-wrap">
          <Colors
            v-show="colorsArr.length != 0"
            :colorType.sync="mainColID"
            :currColor="mainColID"
            :colors="colorsArr"
            contLabel="Cores"
          />
        </div>
      </template>
    </ModelConfig>
    <p
      v-show="showCarLook && isMobile"
      class="btn-secondary"
      @click="displayCarOptions"
    >
      <span
        ><b>Selecionar {{ staticText.dsgExtLabels[0] }}</b> ({{
          getAllColorsLenght
        }}
        {{ staticText.dsgExtLabels[1] }})</span
      >
    </p>
    <div class="container-wrapContent">
      <FeaturedBlock
        :secTitle="dataBO.destaqueSect.destaqueTitle"
        :content="dataBO.destaqueSect.destaqueContent"
      />
      <Accordion :accordionObj="dataBO.faqs.faqsExt" />
      <LegalMentions />
    </div>
  </div>
</template>
<script>
import ModelConfig from "../components/TemplateParts/ModelConfig/ModelConfig.vue";
import Model from "../components/TemplateParts/Model/Model.vue";
import DetailsViewNav from "../components/TemplateParts/SimpleContent/DetailsViewNav.vue";
import Colors from "../components/TemplateParts/SimpleContent/Colors.vue";
import Accordion from "../components/TemplateParts/SimpleContent/Accordion.vue";
import FeaturedBlock from "../components/TemplateParts/SimpleContent/FeaturedBlock.vue";
import LegalMentions from "../components/TemplateParts/SimpleContent/LegalMentions.vue";
import { comonFunctions } from "../mixins/comonFunctions";
import { metatags } from "../mixins/comonMetaTags";
import { mapGetters, mapState } from "vuex";

export default {
  name: "DesignExterior",
  components: {
    ModelConfig,
    Model,
    DetailsViewNav,
    Colors,
    Accordion,
    FeaturedBlock,
    LegalMentions,
  },
  mixins: [metatags, comonFunctions],
  data() {
    return {
      lenght: 7,
      mainColID: 0,
      colorsArr: [],
      imgsArr: null,
      seoData: {
        title: "Configurador",
        titleTemplate: "Exterior",
        author: "Hyundai Portugal",
        og_description:
          "Com o Configurador Hyundai, pode escolher e personalizar o seu Hyundai de sonho. Selecione o seu modelo favorito e escolha todas as características de acordo com as suas preferências.",
        og_title: "Configurador Hyundai - Hyundai Portugal",
        og_locale: "pt_PT",
        og_type: "article",
        og_site_name: "Hyundai Portugal",
      },
    };
  },
  beforeMount() {
    let id = this.resumeData.configSelected.dsgExt?.colorid;
    this.mainColID = id ? id : 0;
  },
  mounted() {
    let extArr = this.currModel360(
      this.resumeData.modelid,
      this.resumeData.versionID
    );

    if (extArr) {
      Object.entries(extArr).forEach((el) => {
        this.colorsArr.push({
          id: el[1].id,
          designation: el[1].designation,
          chip: el[1].colorchip,
          price: el[1].price,
          factoryCode: el[1].factoryCode,
          type: el[1].paintingType
        });
      });
      this.handleStarterColor();
    }
  },
  provide: {
    page: "Exterior",
    isExtColor: true,
  },
  watch: {
    mainColID: function (val, prev) {
      this.mainColID = val;
      let _arr = this.currModel360(
        this.resumeData.modelid,
        this.resumeData.versionID
      );
      this.imgsArr = _arr.find((el) => el.id == val)?.externalColorImages360;

      if (prev != 0 && this.isMobile) this.displayCarOptions();
    },
  },
  computed: {
    ...mapState(["resumeData"]),
    ...mapGetters({
      currModel360: "images360/get360ImgByVersion",
    }),
    getAllColorsLenght() {
      return this.colorsArr.length;
    },
  },
  methods: {
    getPageTitle() {
      return `Selecione a <b>Cor Exterior</b> do seu ${this.resumeData.model}`;
    },
    handleStarterColor() {
      const resumeColID = this.resumeData.configSelected?.dsgExt?.colorid;
      const colorsIds = this.colorsArr.map((el) => el.id);

      if (resumeColID) {
        this.mainColID = colorsIds.includes(resumeColID)
          ? resumeColID
          : colorsIds[0];

        return;
      }

      this.mainColID = colorsIds[0];
    },
  },
};
</script>
